import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import homeBanner from '../images/homeBanner.jpg';
import HomePage1 from '../images/HomePage1.jpg';
import HomePage2 from '../images/HomePage2.jpg';
import Homepage3 from '../images/Homepage3.jpeg';
import Homepage4 from '../images/Homepage4.jpeg';
import Homepage5 from '../images/Homepage5.jpg';
import './Home.css';

const Home = () => {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    pan: '',
    aadhar: '',
    dob: '',
    employmentType: '',
    gender: '',
    state: '',
    city: '',
    pincode: '',
    loanAmount: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Carousel state
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // EMI Calculator state
  const [emiData, setEmiData] = useState({
    loanAmount: 500000,
    interestRate: 12,
    tenure: 6 // months (1-12)
  });
  
  // Contact form state
  const [contactData, setContactData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  
  // Carousel images in sequence
  const carouselImages = [
    HomePage1,
    HomePage2,
    Homepage3,
    Homepage4,
    Homepage5
  ];
  
  // Carousel products data
  const carouselProducts = [
    {
      title: 'Loan Against Property',
      description: 'Unlock the value of your property for business or personal needs.',
      image: HomePage1
    },
    {
      title: 'Personal Loan',
      description: 'Quick and easy personal loans for your immediate financial needs.',
      image: HomePage2
    },
    {
      title: 'Invoice Discounting',
      description: 'Convert your outstanding invoices into immediate cash flow.',
      image: Homepage3
    },
    {
      title: 'Business Loan',
      description: 'Fuel your business growth with our flexible financing solutions.',
      image: Homepage4
    },
    {
      title: 'Vehicle Loan',
      description: 'Drive away with your desired vehicle through our financing solutions.',
      image: Homepage5
    }
  ];
  
  // Carousel functions
  const handleNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselProducts.length);
  };
  
  const handlePrevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + carouselProducts.length) % carouselProducts.length);
  };
  
  // EMI Calculator function
  const calculateEMI = () => {
    const principal = emiData.loanAmount;
    const rate = emiData.interestRate / 100 / 12;
    const time = emiData.tenure; // already in months
    
    const emi = (principal * rate * Math.pow(1 + rate, time)) / (Math.pow(1 + rate, time) - 1);
    return Math.round(emi);
  };
  
  // Contact form handler
  const handleContactSubmit = (e) => {
    e.preventDefault();
    alert('Message sent successfully! We will contact you soon.');
    setContactData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Reset city when state changes
    if (name === 'state') {
      setFormData({
        ...formData,
        [name]: value,
        city: '' // Reset city when state changes
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      alert('Application submitted successfully! We will contact you soon.');
      setFormData({
        name: '',
        mobile: '',
        email: '',
        pan: '',
        aadhar: '',
        dob: '',
        employmentType: '',
        gender: '',
        state: '',
        city: '',
        pincode: '',
        loanAmount: ''
      });
    }, 2000);
  };

  const states = [
    'Select State',
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal'
  ];

  const cities = {
    'Andhra Pradesh': ['Select City', 'Visakhapatnam', 'Vijayawada', 'Guntur', 'Nellore', 'Tirupati', 'Kurnool', 'Rajahmundry'],
    'Arunachal Pradesh': ['Select City', 'Itanagar', 'Naharlagun', 'Tawang', 'Bomdila', 'Pasighat'],
    'Assam': ['Select City', 'Guwahati', 'Silchar', 'Dibrugarh', 'Jorhat', 'Nagaon', 'Tinsukia'],
    'Bihar': ['Select City', 'Patna', 'Gaya', 'Bhagalpur', 'Muzaffarpur', 'Purnia', 'Darbhanga'],
    'Chhattisgarh': ['Select City', 'Raipur', 'Bhilai', 'Bilaspur', 'Korba', 'Raigarh', 'Durg'],
    'Goa': ['Select City', 'Panaji', 'Margao', 'Vasco da Gama', 'Mapusa', 'Ponda'],
    'Gujarat': ['Select City', 'Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Bhavnagar', 'Jamnagar', 'Gandhinagar'],
    'Haryana': ['Select City', 'Gurgaon', 'Faridabad', 'Panipat', 'Ambala', 'Karnal', 'Yamunanagar'],
    'Himachal Pradesh': ['Select City', 'Shimla', 'Mandi', 'Solan', 'Dharamshala', 'Kullu', 'Manali'],
    'Jharkhand': ['Select City', 'Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro', 'Hazaribagh', 'Deoghar'],
    'Karnataka': ['Select City', 'Bangalore', 'Mysore', 'Hubli', 'Mangalore', 'Belgaum', 'Gulbarga', 'Davangere'],
    'Kerala': ['Select City', 'Kochi', 'Thiruvananthapuram', 'Kozhikode', 'Thrissur', 'Kollam', 'Alappuzha'],
    'Madhya Pradesh': ['Select City', 'Indore', 'Bhopal', 'Gwalior', 'Jabalpur', 'Ujjain', 'Raipur'],
    'Maharashtra': ['Select City', 'Mumbai', 'Pune', 'Nagpur', 'Nashik', 'Aurangabad', 'Solapur', 'Thane'],
    'Manipur': ['Select City', 'Imphal', 'Thoubal', 'Bishnupur', 'Churachandpur'],
    'Meghalaya': ['Select City', 'Shillong', 'Tura', 'Jowai', 'Nongpoh'],
    'Mizoram': ['Select City', 'Aizawl', 'Lunglei', 'Champhai', 'Saiha'],
    'Nagaland': ['Select City', 'Kohima', 'Dimapur', 'Mokokchung', 'Tuensang'],
    'Odisha': ['Select City', 'Bhubaneswar', 'Cuttack', 'Rourkela', 'Berhampur', 'Sambalpur', 'Puri'],
    'Punjab': ['Select City', 'Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala', 'Bathinda', 'Mohali'],
    'Rajasthan': ['Select City', 'Jaipur', 'Jodhpur', 'Kota', 'Bikaner', 'Ajmer', 'Udaipur', 'Alwar'],
    'Sikkim': ['Select City', 'Gangtok', 'Namchi', 'Mangan', 'Gyalshing'],
    'Tamil Nadu': ['Select City', 'Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli', 'Salem', 'Tirunelveli', 'Erode'],
    'Telangana': ['Select City', 'Hyderabad', 'Warangal', 'Nizamabad', 'Karimnagar', 'Ramagundam', 'Khammam'],
    'Tripura': ['Select City', 'Agartala', 'Udaipur', 'Dharmanagar', 'Kailasahar'],
    'Uttar Pradesh': ['Select City', 'Lucknow', 'Kanpur', 'Agra', 'Varanasi', 'Allahabad', 'Meerut', 'Noida'],
    'Uttarakhand': ['Select City', 'Dehradun', 'Haridwar', 'Rishikesh', 'Nainital', 'Mussoorie', 'Haldwani'],
    'West Bengal': ['Select City', 'Kolkata', 'Howrah', 'Durgapur', 'Asansol', 'Siliguri', 'Bardhaman']
  };

  return (
    <div className="home-page">
      {/* Main Hero Section with Two Columns */}
      <section className="hero-section">
        <div className="hero-container">
          {/* Left Column - Promotional Content */}
          <div className="hero-left" style={{ backgroundImage: `url(${homeBanner})` }}>
            <div className="hero-content">
              <p className="hero-tagline">YOUR FINANCIAL LOAN'S EXPERT</p>
              <h1 className="home-title">
                EMPOWERING YOUR<br />FINANCIAL FUTURE
              </h1>
              <p className="hero-subtitle">
                Ampire Finance is your trusted partner for your personalised financial requirements.
              </p>
              <a 
                href="#our-services" 
                className="hero-btn" 
                style={{ textDecoration: 'none', display: 'inline-block' }}
                onClick={(e) => {
                  e.preventDefault();
                  const element = document.getElementById('our-services');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
              >
                EXPLORE OUR LOANS
              </a>
            </div>
          </div>

          {/* Right Column - Application Form */}
          <div className="hero-right">
            <div className="loan-form-wrapper">
              <h2 className="form-title">APPLICATION FORM</h2>
              
              <form onSubmit={handleSubmit} className="application-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">NAME *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="As On PAN Card"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="mobile">MOBILE NUMBER *</label>
                    <input
                      type="tel"
                      id="mobile"
                      name="mobile"
                      placeholder="Mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">EMAIL *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Personal Email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="pan">PAN *</label>
                    <input
                      type="text"
                      id="pan"
                      name="pan"
                      placeholder="PAN"
                      value={formData.pan}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="aadhar">AADHAR NUMBER *</label>
                    <input
                      type="text"
                      id="aadhar"
                      name="aadhar"
                      placeholder="Aadhar Number"
                      value={formData.aadhar}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="dob">DATE OF BIRTH *</label>
                    <input
                      type="date"
                      id="dob"
                      name="dob"
                      placeholder="Date of Birth"
                      value={formData.dob}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="employmentType">EMPLOYMENT TYPE *</label>
                    <select
                      id="employmentType"
                      name="employmentType"
                      value={formData.employmentType}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select</option>
                      <option value="salaried">Salaried</option>
                      <option value="self-employed">Self Employed</option>
                      <option value="business">Business</option>
                      <option value="professional">Professional</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="gender">GENDER *</label>
                    <select
                      id="gender"
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="state">SELECT STATE *</label>
                    <select
                      id="state"
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                      required
                    >
                      {states.map((state, index) => (
                        <option key={index} value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="city">SELECT CITY *</label>
                    <select
                      id="city"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      required
                      disabled={!formData.state || formData.state === 'Select State' || !cities[formData.state]}
                    >
                      <option value="">
                        {!formData.state || formData.state === 'Select State' || !cities[formData.state] 
                          ? 'Select State First' 
                          : 'Select City'}
                      </option>
                      {formData.state && cities[formData.state] && cities[formData.state].map((city, index) => (
                        <option key={index} value={city}>
                          {city}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="pincode">PIN CODE *</label>
                    <input
                      type="text"
                      id="pincode"
                      name="pincode"
                      placeholder="Pincode"
                      value={formData.pincode}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="loanAmount">LOAN AMOUNT *</label>
                    <input
                      type="number"
                      id="loanAmount"
                      name="loanAmount"
                      placeholder="Loan Amount"
                      value={formData.loanAmount}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="disclaimer">
                  <p>
                    By submitting this form, I authorize Ampire Finance and its representatives to Call, SMS, WhatsApp or Email me regarding my loan application. This consent overrides my registration for DNC/NDNC. I confirm that I am above 18 years of age and a resident of India. I agree to the Privacy Policy and authorize Ampire Finance to contact me.
                  </p>
                </div>

                <button
                  type="submit"
                  className={`submit-btn ${isSubmitting ? 'loading' : ''}`}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'SUBMITTING...' : 'SUBMIT'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Our Services Section */}
      <section id="our-services" className="services-section">
        <div className="container">
          <h2 className="services-title">OUR SERVICES</h2>
          <div className="services-divider"></div>
        </div>
        
        {/* Service Cards */}
        <div className="services-container">
            {/* Loan Against Property */}
            <div className="service-card">
              <div className="service-content">
                <div className="service-category">Loans</div>
                <h3 className="service-title">LOAN AGAINST PROPERTY</h3>
                <p className="service-description">
                  At Ampire Finance, our Loan Against Property (LAP) service empowers you to tap into the equity of your real estate assets. By using your property as collateral, you can access substantial funds for various purposes, such as business expansion, home renovation, or personal expenses, without having to sell your property.
                </p>
                <Link to="/loans/property" className="learn-more-btn">LEARN MORE</Link>
              </div>
              <div className="service-image">
                <img 
                  src={HomePage1} 
                  alt="Loan Against Property"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              </div>
            </div>

            {/* Loans Against Shares */}
            <div className="service-card reverse">
              <div className="service-content">
                <div className="service-category">Loans</div>
                <h3 className="service-title">LOANS AGAINST SHARES</h3>
                <p className="service-description">
                  At Ampire Finance, we offer a tailored Loan Against Shares (LAS) service designed to help you unlock the potential of your investments. By using your shares as collateral, you can secure funds without the need to sell your assets. Our competitive interest rates and flexible repayment options ensure that you can access the liquidity you need while maintaining ownership of your investments.
                </p>
                <Link to="/loans/shares" className="learn-more-btn">LEARN MORE</Link>
              </div>
              <div className="service-image">
                <img 
                  src={HomePage2} 
                  alt="Loans Against Shares"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              </div>
            </div>

            {/* Invoice Discounting */}
            <div className="service-card">
              <div className="service-content">
                <div className="service-category">Loans</div>
                <h3 className="service-title">INVOICE DISCOUNTING</h3>
                <p className="service-description">
                  At Ampire Finance, we recognize that cash flow is crucial for your business operations. Our invoice discounting service offers a flexible solution to unlock immediate capital tied up in your outstanding invoices. With our straightforward application process and competitive rates, you can convert your receivables into cash without waiting for customer payments. We provide transparent terms and expert guidance to help you navigate the process efficiently.
                </p>
                <Link to="/loans/invoice-discounting" className="learn-more-btn">LEARN MORE</Link>
              </div>
              <div className="service-image">
                <img 
                  src={Homepage3} 
                  alt="Invoice Discounting"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              </div>
            </div>

            {/* Personal Loans */}
            <div className="service-card reverse">
              <div className="service-content">
                <div className="service-category">Loans</div>
                <h3 className="service-title">PERSONAL LOANS</h3>
                <p className="service-description">
                  At Ampire Finance, we understand that personal loans can play a vital role in achieving your financial goals. Our personal loan services are tailored to meet a variety of needs and budgets, ensuring there's a financing option that fits your situation. With competitive rates and flexible terms, we make it simple for you to access the funds you need while providing the support you deserve throughout the loan process.
                </p>
                <Link to="/loans/personal" className="learn-more-btn">LEARN MORE</Link>
              </div>
              <div className="service-image">
                <img 
                  src={Homepage4} 
                  alt="Personal Loans"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              </div>
            </div>

            {/* Used Vehicle Loan */}
            <div className="service-card">
              <div className="service-content">
                <div className="service-category">Loans</div>
                <h3 className="service-title">USED VEHICLE LOAN</h3>
                <p className="service-description">
                  At Ampire Finance, we recognize that owning a vehicle is an essential step towards achieving mobility and convenience in your life. Our vehicle loan services are designed to cater to a variety of financial goals and budgets, ensuring there's a financing option that suits your needs. With competitive rates and flexible terms, we make it easy for you to drive your dream vehicle while providing the support you need throughout the loan process.
                </p>
                <Link to="/loans/used-vehicle" className="learn-more-btn">LEARN MORE</Link>
              </div>
              <div className="service-image">
                <img 
                  src={Homepage5} 
                  alt="Used Vehicle Loan"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              </div>
            </div>
          </div>
      </section>

      {/* Our Product Portfolio Section */}
      <section className="portfolio-section">
        <div className="container">
          <h2 className="portfolio-title">OUR PRODUCT PORTFOLIO</h2>
          <p className="portfolio-subtitle">Discover Flexible Loan Solutions Tailored to Your Unique Financial Needs and Goals</p>
          <div className="portfolio-divider">
            <div className="divider-line"></div>
            <div className="divider-dots">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          </div>
          
          <div className="portfolio-cards">
            <div className="portfolio-card">
              <h3 className="card-title">LOAN AGAINST PROPERTY</h3>
              <p className="card-description">
                Loans in the range of ₹5 lakhs to ₹1 crores.
              </p>
              <Link to="/loans/property" className="card-btn">READ MORE</Link>
            </div>
            
            <div className="portfolio-card">
              <h3 className="card-title">LOAN AGAINST SHARES</h3>
              <p className="card-description">
                Loan against shares starting from 12%*.
              </p>
              <Link to="/loans/shares" className="card-btn">READ MORE</Link>
            </div>
            
            <div className="portfolio-card">
              <h3 className="card-title">PERSONAL LOAN</h3>
              <p className="card-description">
                Loans availability for 12 to 48 months.
              </p>
              <Link to="/loans/personal" className="card-btn">READ MORE</Link>
            </div>
            
            <div className="portfolio-card">
              <h3 className="card-title">USED VEHICLE LOAN</h3>
              <p className="card-description">
                Loans availability for up to 5 years.
              </p>
              <Link to="/loans/used-vehicle" className="card-btn">READ MORE</Link>
            </div>
            
            <div className="portfolio-card">
              <h3 className="card-title">INVOICE DISCOUNTING</h3>
              <p className="card-description">
                Minimizes the impact on financial statements.
              </p>
              <Link to="/loans/invoice-discounting" className="card-btn">READ MORE</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Ampire Finance Section */}
      <section className="why-choose-section">
        <div className="container">
          <h2 className="why-choose-title">WHY CHOOSE AMPIRE FINANCE?</h2>
          <p className="why-choose-subtitle">YOUR PATH TO EFFORTLESS FINANCIAL SOLUTIONS!</p>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📄</div>
              <h3 className="feature-title">100% PAPERLESS PROCESS</h3>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">📋</div>
              <h3 className="feature-title">MINIMAL DOCUMENTATION</h3>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">⚙️</div>
              <h3 className="feature-title">SIMPLE & SECURE PROCESS</h3>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">💬</div>
              <h3 className="feature-title">24/7 CUSTOMER SUPPORT</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Carousel Section */}
      <section className="carousel-section">
        <div className="container">
          <div className="carousel-container">
            <button className="carousel-arrow carousel-arrow-left" onClick={handlePrevSlide}>
              ‹
            </button>
            
            <div className="carousel-track">
              {carouselProducts.map((product, index) => (
                <div
                  key={index}
                  className={`carousel-card ${
                    index === currentSlide ? 'active' : 
                    index === currentSlide - 1 || index === currentSlide + 1 ? 'adjacent' : 'inactive'
                  }`}
                >
                  <div className="card-image">
                    <img 
                      src={product.image || carouselImages[index]} 
                      alt={product.title}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  </div>
                  <div className="card-overlay">
                    <h3 className="card-title">{product.title}</h3>
                  </div>
                </div>
              ))}
            </div>
            
            <button className="carousel-arrow carousel-arrow-right" onClick={handleNextSlide}>
              ›
            </button>
          </div>
        </div>
      </section>

      {/* EMI Calculator Section */}
      <section className="emi-calculator-section">
        <div className="container">
          <div className="emi-grid">
            <div className="emi-info">
              <h2 className="emi-title">CALCULATE YOUR MONTHLY LOAN PAYMENTS INSTANTLY</h2>
              <ul className="emi-features">
                <li>✓ Calculate your EMI instantly to plan your finances with ease.</li>
                <li>✓ Adjust the loan amount, interest rate, and tenure for quick estimates.</li>
                <li>✓ Understand your monthly repayment obligations at a glance.</li>
                <li>✓ Make informed financial decisions and choose the right loan terms for your budget.</li>
                <li>✓ Channel Partner Recognition.</li>
                <li>✓ Start planning your financial journey today!</li>
              </ul>
              <Link to="/contact" className="contact-btn">CONTACT US</Link>
            </div>
            
            <div className="emi-calculator">
              <h3 className="calculator-title">CALCULATE YOUR AFFORDABLE EMI TODAY!</h3>
              <div className="calculator-inputs">
                <div className="input-group">
                  <label>LOAN AMOUNT</label>
                  <div className="input-with-slider">
                    <input
                      type="text"
                      value={`₹ ${emiData.loanAmount.toLocaleString()}`}
                      readOnly
                      className="value-input"
                    />
                    <div className="slider-wrapper">
                      <input
                        type="range"
                        min="5000"
                        max="5000000"
                        value={emiData.loanAmount}
                        onChange={(e) => setEmiData({...emiData, loanAmount: parseInt(e.target.value)})}
                        className="slider"
                        style={{
                          '--slider-progress': `${((emiData.loanAmount - 5000) / (5000000 - 5000)) * 100}%`
                        }}
                      />
                    </div>
                  </div>
                </div>
                
                <div className="input-group">
                  <label>INTEREST RATE</label>
                  <div className="input-with-slider">
                    <input
                      type="text"
                      value={`% ${emiData.interestRate}`}
                      readOnly
                      className="value-input"
                    />
                    <div className="slider-wrapper">
                      <input
                        type="range"
                        min="0.5"
                        max="25"
                        step="0.1"
                        value={emiData.interestRate}
                        onChange={(e) => setEmiData({...emiData, interestRate: parseFloat(e.target.value)})}
                        className="slider"
                        style={{
                          '--slider-progress': `${((emiData.interestRate - 0.5) / (25 - 0.5)) * 100}%`
                        }}
                      />
                    </div>
                  </div>
                </div>
                
                <div className="input-group">
                  <label>LOAN TENURE</label>
                  <div className="input-with-slider">
                    <input
                      type="text"
                      value={`${emiData.tenure} Month${emiData.tenure !== 1 ? 's' : ''}`}
                      readOnly
                      className="value-input"
                    />
                    <div className="slider-wrapper">
                      <input
                        type="range"
                        min="1"
                        max="12"
                        value={emiData.tenure}
                        onChange={(e) => setEmiData({...emiData, tenure: parseInt(e.target.value)})}
                        className="slider"
                        style={{
                          '--slider-progress': `${((emiData.tenure - 1) / (12 - 1)) * 100}%`
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="emi-results">
                <div className="result-item">
                  <span className="result-label">Monthly EMI</span>
                  <span className="result-value emi-value">₹{calculateEMI().toLocaleString()}</span>
                </div>
                <div className="result-item">
                  <span className="result-label">Principal Amount</span>
                  <span className="result-value principal-value">₹{emiData.loanAmount.toLocaleString()}</span>
                </div>
                <div className="result-item">
                  <span className="result-label">Interest Payable</span>
                  <span className="result-value interest-value">₹{(calculateEMI() * emiData.tenure - emiData.loanAmount).toLocaleString()}</span>
                </div>
                <div className="result-item">
                  <span className="result-label">Total Amount Payable</span>
                  <span className="result-value total-value">₹{(calculateEMI() * emiData.tenure).toLocaleString()}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-form-section">
        <div className="container">
          {/* <div className="contact-top">
            <button className="contact-us-btn">CONTACT US</button>
            <div className="blue-arrow">→</div>
            <div className="total-amount-box">
              <div className="total-label">Total Amount Payable</div>
              <div className="total-value">₹{(calculateEMI() * emiData.tenure).toLocaleString()}</div>
            </div>
          </div> */}
          
          <div className="contact-grid">
            <div className="contact-form">
              <form onSubmit={handleContactSubmit} className="message-form">
                <div className="form-group">
                  <label>NAME</label>
                  <input
                    type="text"
                    placeholder="Name"
                    value={contactData.name}
                    onChange={(e) => setContactData({...contactData, name: e.target.value})}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label>EMAIL</label>
                  <input
                    type="email"
                    placeholder="Email"
                    value={contactData.email}
                    onChange={(e) => setContactData({...contactData, email: e.target.value})}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label>MESSAGE</label>
                  <textarea
                    placeholder="Message"
                    value={contactData.message}
                    onChange={(e) => setContactData({...contactData, message: e.target.value})}
                    required
                  ></textarea>
                </div>
                
                <button type="submit" className="send-btn">
                  SEND
                </button>
              </form>
            </div>
            
            <div className="contact-info">
              <h2 className="contact-title">LEAVE A MESSAGE</h2>
              <h3 className="contact-subtitle">GET IN TOUCH WITH US FOR BEST ADVICE ON BUSINESS</h3>
              <p className="contact-description">
                At Ampire Finance, we're dedicated to helping you achieve your financial goals. Whether you have questions about our services, need assistance with your account, or want to provide feedback, our team is here for you.
              </p>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;
